import React, { useState } from 'react';
import * as Styles from './ChangeDomain.styles';
import {
  Button, Checkbox, IconArrow, IconExternalLink,
} from 'gatorcomponents';
import snappyTool from '@/media/domains/snappy-tool.svg';

const ChangeDomain = ({
  backButton,
  continueButton,
  locale,
  newDomain,
  icon,
  mobile,
}) => {
  const [agreed, setAgreed] = useState(false);

  return (
    <Styles.ComponentWrapper data-testid="change-domain-success">
      <Styles.HeadWrapper>
        {icon && (
          <Styles.IconCircle>
            {icon}
          </Styles.IconCircle>
        )}
        <Styles.Wrapper>
          <Styles.Title>
            {locale.title(newDomain)}
          </Styles.Title>
          <Styles.Description>
            {locale.description}
          </Styles.Description>
        </Styles.Wrapper>
      </Styles.HeadWrapper>
      <Styles.Wrapper>
        {locale.advise && (
        <Styles.AdviseWrapper>
          <Styles.SnappyWrapper>
            <Styles.SnappyImage src={snappyTool} />
          </Styles.SnappyWrapper>
          <Styles.AdviseText>
            {locale.advise}
          </Styles.AdviseText>
        </Styles.AdviseWrapper>
        )}
        <Styles.Agreed>
          <Styles.CheckboxLabel
            htmlFor="#agreed"
            onClick={() => setAgreed(!agreed)}
            data-testid="checkAgreed"
          >
            <Checkbox checked={agreed} id="agreed" />
            {' '}
            {locale.checkBoxLabel}
          </Styles.CheckboxLabel>
        </Styles.Agreed>
      </Styles.Wrapper>
      <Styles.ButtonsWrapper>
        {backButton && (
          <Button
            label={backButton.label}
            variant={backButton.variant}
            width={mobile ? 'full' : 'fit'}
            size="medium2"
            iconRight={backButton.iconRight && <IconArrow direction="right" />}
            onClick={backButton.action}
            testId="back-button"
          />
        )}
        {continueButton && (
          <Styles.ButtonWrapperAdapter>
            <Button
              label={continueButton.label}
              variant={continueButton.variant}
              width={mobile ? 'full' : 'fit'}
              size="medium2"
              iconRight={continueButton.iconRight && <IconExternalLink backgroundColor="transparent" color={!agreed ? 'lowLight' : 'highPure'} secondaryColor="transparent" size="sm" />}
              onClick={continueButton.action}
              testId="continue-button"
              disabled={!agreed}
              notFillSVG
            />
          </Styles.ButtonWrapperAdapter>
        )}
      </Styles.ButtonsWrapper>
    </Styles.ComponentWrapper>
  );
};

export default ChangeDomain;
